import {Collars, Traps, DropOffs, ExternalSensors, Cameras, ConfigurationDevices, DataLoggers, TT4Sensors} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class ItemsServices {
  constructor(
    public collar: Collars,
    public trap: Traps,
    public dropOff: DropOffs,
    public externalSensor: ExternalSensors,
    public camera: Cameras,
    public configurationDevice: ConfigurationDevices,
    public dataLogger: DataLoggers,
    public tt4Sensor: TT4Sensors,
  ) {}
}